import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { LANGUAGE_DETECTION, LOCALES } from '@/shared/lib/locale';

/**
 * Interface translations. Each language and namespace is its own JSON file under
 * public/locales, fetched only when needed, so adding a language adds no weight
 * for everyone else.
 *
 * Language choice: shared/lib/locale.ts, LANGUAGE_DETECTION (the address, this device,
 * another host or the front page, the browser); a signed-in account's language applies
 * when the device has no choice of its own (see App.tsx).
 */
void i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: [...LOCALES],
    fallbackLng: 'en',
    // "zh-CN" and "ru-RU" resolve to "zh" and "ru".
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    ns: ['common', 'exercises', 'music'],
    defaultNS: 'common',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      // A new build must not be served the previous build's cached translations.
      queryStringParams: { v: import.meta.env.VITE_BUILD_ID ?? 'dev' },
    },
    detection: LANGUAGE_DETECTION,
    interpolation: { escapeValue: false }, // React escapes on its own
  });

i18n.on('languageChanged', (language) => {
  document.documentElement.lang = language;
});

export default i18n;
